/*
 * Permissive phone number format check for early client-side feedback. The back-end performs the
 * authoritative validation (E.164 normalization).
 */
const PHONE_PATTERN = /^\+?[0-9\s().-]{6,}$/;

function isValidPhoneNumber(phoneNumber : string | undefined) : boolean {
    return phoneNumber !== null && phoneNumber !== undefined && PHONE_PATTERN.test(phoneNumber);
}

export const PhoneUtils = () => {
    return
}

PhoneUtils.isValidPhoneNumber = isValidPhoneNumber;
